.wrap {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  flex: none;
}

/* Квадратные кнопки-иконки: снимок и история. Подпись живёт в подсказке.
   Сторона квадрата — общая высота контролов полосы (tokens.css). position:
   relative — точка ошибки и замок гостя стоят на кнопке абсолютно. */
.iconBtn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--ctl-h);
  height: var(--ctl-h);
  padding: 0;
  color: var(--text-2);
}

.iconBtn:hover:not(:disabled) {
  color: var(--text);
}

/* Пока не ясно, гость или вошедший (первый /api/auth/me) — место под кнопки
   держит заглушка той же ширины, чтобы полоса не дёргалась. */
.placeholder {
  display: inline-block;
  width: calc(var(--ctl-h) * 2 + var(--sp-2));
  height: var(--ctl-h);
  flex: none;
}

/* Маркер конфликта/отказа сервера на кнопке-дискете — тот же приём, что у
   неподтверждённой почты в AccountButton. Обводка цветом поверхности отделяет
   точку от иконки под ней. */
.statusDot {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 0 2px var(--surface);
}

.statusDot.warn {
  color: var(--warn);
}

.statusDot.error {
  color: var(--error);
}

/* Замок гостя в углу кнопки: значок остаётся тем же (дискета/журнал), а
   замок лишь поясняет, что механизм — за входом. */
.lockBadge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  background: var(--surface);
  border-radius: 50%;
  color: var(--text-3);
  box-shadow: 0 0 0 1px var(--border);
}

.menu {
  position: absolute;
  top: calc(100% + var(--sp-2));
  right: 0;
  z-index: 40;
  width: 280px;
  max-height: 320px;
  overflow-y: auto;
  padding: var(--sp-2);
  background: var(--surface);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius-lg);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  box-shadow: var(--glass-rim), var(--shadow-lift);
}

.empty {
  padding: var(--sp-4);
  color: var(--text-3);
  font-size: var(--fs-sm);
  line-height: 1.5;
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--sp-4);
  width: 100%;
  padding: var(--sp-3) var(--sp-4);
  background: none;
  border: none;
  border-radius: var(--radius);
  text-align: left;
  cursor: pointer;
}

.item:hover {
  background: var(--surface-2);
}

.itemLabel {
  font-size: var(--fs-sm);
  color: var(--text);
}

.itemMeta {
  flex: none;
  font-size: var(--fs-xs);
  color: var(--text-3);
}

/* Отдельный слой под кнопками: полоса обязана оставаться одной строкой,
   поэтому сообщение не участвует в её потоке. */
.toast {
  position: absolute;
  top: calc(100% + var(--sp-2));
  right: 0;
  z-index: 30;
  padding: var(--sp-2) var(--sp-4);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-card);
  color: var(--text-2);
  font-size: var(--fs-xs);
  white-space: nowrap;
}

/* Гостю снимок и журнал недоступны напрямую: кнопка притушена, но не
   disabled — клик по ней зовёт вход (requestSignIn), а не молчит. */
.locked {
  opacity: 0.5;
}

.locked:hover {
  background: inherit;
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ────────
   Кнопки уезжают внутрь бургер-меню, а у того своя прокрутка: список снимков,
   висящий absolute у кнопки, она бы обрезала. Поэтому и список, и сообщение
   привязаны к экрану — нижней шторкой поверх меню. */
@media (max-width: 720px) {
  .iconBtn {
    width: 40px;
    height: 40px;
  }

  .placeholder {
    width: calc(40px * 2 + var(--sp-2));
    height: 40px;
  }

  .menu {
    position: fixed;
    inset: auto var(--sp-4) var(--sp-4) var(--sp-4);
    z-index: 1100;
    width: auto;
    max-height: 50vh;
  }

  .item {
    min-height: 44px;
  }

  .toast {
    position: fixed;
    top: auto;
    right: var(--sp-4);
    bottom: var(--sp-4);
    left: var(--sp-4);
    z-index: 1100;
    text-align: center;
    white-space: normal;
  }
}
